import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface Template {
  id: string;
  name: string;
  description: string;
}

@Component({
  selector: 'app-template-selection-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './template-selection-modal.component.html',
  styleUrls: ['./template-selection-modal.component.scss']
})
export class TemplateSelectionModalComponent implements OnInit, OnDestroy {
  selectedTemplate: string | null = null;
  isLoading = false;
  private destroy$ = new Subject<void>();
  
  templates: Template[] = [
    { id: '1', name: 'Project Management Template', description: 'Basic project structure with tasks and milestones' },
    { id: '2', name: 'Marketing Campaign', description: 'Template for planning and executing marketing campaigns' },
    { id: '3', name: 'Product Development', description: 'End-to-end product development workflow' },
    { id: '4', name: 'Event Planning', description: 'Complete event planning and management template' },
    { id: '5', name: 'Content Calendar', description: 'Editorial and content planning calendar' },
    { id: '6', name: 'Agile Sprint', description: 'Scrum-based agile development sprint template' },
    { id: '7', name: 'Customer Onboarding', description: 'Step-by-step customer onboarding process' },
    { id: '8', name: 'Website Redesign', description: 'Template for website redesign projects' },
    { id: '9', name: 'Social Media Strategy', description: 'Comprehensive social media planning' },
    { id: '10', name: 'Quarterly Planning', description: 'Template for quarterly business planning' },
  ];

  constructor(
    public dialogRef: MatDialogRef<TemplateSelectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    // Load templates if needed
    this.isLoading = true;
    // Simulate API call
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
  }

  onSearch(term: string): void {
    // Handle search functionality
    console.log('Searching for:', term);
  }

  onAttach(): void {
    if (this.selectedTemplate) {
      const selectedTemplate = this.templates.find(t => t.id === this.selectedTemplate);
      this.dialogRef.close({
        templateId: this.selectedTemplate,
        templateName: selectedTemplate?.name || ''
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
